import {store} from "../../../helper/store";
import {updateExposure} from "../../../redux_actions/maps.state.action";


export const getExposureName = (slide, exposure) =>
	exposure && ((slide.meta?.exposure_name_stack || [])[slide.meta?.exposure_stack?.indexOf(exposure)] ||
		(exposure === 'HDR' ? exposure : `${exposure}μs`));

export const incrementExposure = (slide, currentExposure) => {
	const exposures = slide.meta?.exposure_stack || [];
	store.dispatch(updateExposure(store.getState().gammaStateReducer.activeMapId,
		exposures[exposures.indexOf(currentExposure) + 1] || currentExposure));
}

export const decrementExposure = (slide, currentExposure) => {
	const exposures = slide.meta?.exposure_stack || [];
	store.dispatch(updateExposure(store.getState().gammaStateReducer.activeMapId,
		exposures[exposures.indexOf(currentExposure) - 1] || currentExposure));
}
